var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"renlian-index"},[(!_vm.loading)?[(_vm.isFaceRecognitionEnabled)?_c('RenlianDenglu'):_c('Xuanzejibenxinxi')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }